module.exports = __webpack_public_path__ + "a095ab7b00655c405736d3b2b3afd49f.png";